var _dec, _class;
import { ApiService } from './api-service';
import { inject } from 'aurelia-framework';
import { websiteShortCode } from 'environment';
export let NotificationService = (_dec = inject(ApiService), _dec(_class = class NotificationService {
  constructor(api) {
    this.path = 'Notification';
    this.api = api;
  }
  async getLatestNotifications(userId, count, includeHidden) {
    const params = {
      userId: userId,
      websiteShortCode: websiteShortCode(),
      count: count,
      includeHidden: includeHidden
    };
    return await this.api.doGet(this.path + '/GetLatestNotification', params);
  }
  async markAsRead(notificationsId, state) {
    const data = {
      ids: notificationsId,
      state: state
    };
    return await this.api.doPost(this.path + '/MarkAsRead', data);
  }
  async markAsHidden(notificationsId) {
    return await this.api.doPost(this.path + '/MarkAsHidden', notificationsId);
  }
  async getAllUnreadCount(userId) {
    const params = {
      userId: userId,
      websiteShortCode: websiteShortCode()
    };
    return await this.api.doGet(this.path + '/unreadCount', params);
  }
  async delete(notificationsId) {
    return await this.api.doDelete(this.path + '/Delete', notificationsId);
  }
}) || _class);